import { NO_UPDATE_ERROR } from '../../../../utils/formValidation/commonErrorConstants';
import {
    getReqMessage,
    getSelectMessage
} from '../../../../utils/formValidation/errorMessageFunctions';

export const messages = {
    poNumber:
        'Participant Record is missing a PO number, Initial Appointment cannot be marked as Attended',
    diagnosticQuestionnaire:
        'You must start a Diagnostic Questionnaire with your Participant before Initial Appointment can be marked as Attended. This can be done in the Questionnaire accordion below',
    bookNextAppointment:
        'The Next Appointment booking form above must be completed before Initial Appointment can be marked as Attended',
    initialAppointment: 'Check the Initial Appointment accordion for warning messages',
    gender: 'You must have a value for Gender for your Participant before Initial Appointment can be marked as Attended. This can be set in the General accordion above',
    dateOfBirth:
        'You must have a value for Date of Birth for your Participant before Initial Appointment can be marked as Attended. This can be set in the General accordion above'
};

export const validateAttendance = (currentAppointment) => {
    let newErrors = {};

    if (!currentAppointment.attendanceStatusId) {
        newErrors = {
            ...newErrors,
            appointmentsProceedButton: {
                error: true,
                message: getSelectMessage('attendance status', 'an')
            }
        };
    }
    if (!currentAppointment.calendarAppointmentId) {
        newErrors = {
            ...newErrors,
            appointmentsProceedButton: { error: true, message: getReqMessage('An appointment ID') }
        };
    }
    return newErrors;
};

export const validateUpdateAttendanceStatus = (attendanceStatusId, initialAttendanceStatusId) => {
    let newErrors = {};

    if (attendanceStatusId === initialAttendanceStatusId) {
        newErrors = {
            updateAttendanceStatusButton: { error: true, message: NO_UPDATE_ERROR }
        };
    }

    return newErrors;
};

export const validateAttendanceSelect = (
    state,
    statusId,
    attendedStatusId,
    isRequired,
    hasRequired
) => {
    let newErrors = {};

    if (state?.appointment?.type.toLowerCase() === 'initial' && statusId === attendedStatusId) {
        Object.keys(isRequired).forEach((el) => {
            if (isRequired[el] && !hasRequired[el]) {
                newErrors = {
                    ...newErrors,
                    [el]: {
                        error: true,
                        message: messages[el]
                    }
                };
            }
        });
    }

    return newErrors;
};

export const addWarning = (existingWarnings, newWarning) => {
    return {
        ...existingWarnings,
        [newWarning]: messages[newWarning]
    };
};

export const clearWarning = (existingWarnings, warning) => {
    return (
        Object.fromEntries(Object.entries(existingWarnings).filter(([key]) => key !== warning)) ||
        {}
    );
};
